export const RouteSegments = {
	ROOT: '/',
	LOGIN: 'login',
	ORDER: 'order',
	OVERVIEW: 'overview',
	PICKING: 'picking',
	CHECKING: 'checking',
	RETURNING: 'returning',
	PRODUCTS: 'products',
	CONFIRM: 'confirm',
};

export type RouteSegmentsType = (typeof RouteSegments)[keyof typeof RouteSegments];
